import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { getProgress, loadIndex } from "./knowledgeApi";

const Ctx = createContext(null);

// Topic index (fixed per build) + the signed-in employee's progress, shared across the Knowledge Center.
export function KnowledgeProvider({ children }) {
  const [index, setIndex] = useState(null);
  const [progress, setProgress] = useState(null);
  const [error, setError] = useState(null);

  const refreshProgress = useCallback(() => getProgress().then(setProgress).catch(() => {}), []);
  useEffect(() => {
    loadIndex().then(setIndex).catch(e => setError(e.message));
    refreshProgress();
  }, [refreshProgress]);

  const value = useMemo(() => {
    const cards = {};
    (index?.areas || []).forEach(a => a.groups.forEach(g => g.topics.forEach(t => { cards[t.slug] = t; })));
    const done = new Set(progress?.completed || []);
    return { index, cards, progress, setProgress, refreshProgress, error, isDone: (slug) => done.has(slug),
             areaOf: (id) => index?.areas.find(a => a.id === id) };
  }, [index, progress, error, refreshProgress]);

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useKnowledge() {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error("useKnowledge must be used inside KnowledgeProvider");
  return ctx;
}
